module.exports = __webpack_public_path__ + "static/media/six.e649ff4c.svg";